import { useEffect } from 'react'
import { PropTypes } from 'prop-types'
import { usePortal } from '@web-ui-kit/hooks.use-portal'

const Portal = ({ children, id, scroll }) => {
  const { render } = usePortal(id)
  useEffect(() => {
    if (!scroll) {
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = 'auto'
      }
    }
  }, [])

  return render(children)
}

Portal.defaultProps = {
  scroll: false,
}

Portal.propTypes = {
  children: PropTypes.element.isRequired,
  id: PropTypes.string.isRequired,
  scroll: PropTypes.bool,
}

export default Portal
